import { useRef, useState } from 'react';
import { useSectionMetrics } from '../motion/scroll';
import { useLocale } from '../i18n/locale';
import { sectionId } from '../content/site';
import { HOME, MILESTONE_STATES } from './content';
import { Lines } from './Lines';

/** Portal teaser (COLESCOMEX OS is supporting infrastructure): one illustrative case, clearly disclosed. */
export function Visibility() {
  const { locale } = useLocale(); const copy = HOME[locale].visibility;
  const ref = useRef<HTMLElement>(null);
  const [shown, setShown] = useState(false);
  useSectionMetrics(ref, ({ pass }) => { if (pass > 0.28) setShown(true); });
  return (
    <section ref={ref} id={sectionId('visibility', locale)} className="visibility" data-tone="dark" data-shown={shown} aria-labelledby="visibility-title">
      <div className="visibility__inner wrap">
        <div className="visibility__copy">
          <h2 id="visibility-title" className="section-title"><Lines lines={copy.title} /></h2>
          <p className="section-body">{copy.body}</p>
        </div>
        <figure className="portal">
          <div className="portal__head">
            <p className="portal__project">{copy.project}</p>
            <p className="portal__status"><span className="portal__pulse" aria-hidden="true" />{copy.status}</p>
          </div>
          <div className="portal__body">
            <ol className="portal__milestones">
              {copy.milestones.map((label, index) => {
                const state = MILESTONE_STATES[index];
                return (
                  <li key={label} className={`portal__milestone portal__milestone--${state}`} style={{ transitionDelay: `${index * 110}ms` }}>
                    <span className="portal__node" aria-hidden="true" />
                    <span>{label}</span>
                    <span className="portal__state">{copy.states[state]}</span>
                  </li>
                );
              })}
            </ol>
            <div className="portal__docs">
              <p className="portal__docs-title">{copy.documentsLabel}</p>
              <ul role="list">{copy.documents.map(document => <li key={document}><span className="portal__file" aria-hidden="true" />{document}</li>)}</ul>
            </div>
          </div>
          <figcaption className="portal__note">{copy.note}</figcaption>
        </figure>
      </div>
    </section>
  );
}
